import type { FaireProductEntity } from "../../entity_types/product";

export const p_3uuqtgphb2: FaireProductEntity = {
  token: "p_3uuqtgphb2",
  type: "product",
  name: "Hot Pink and White Lightning Happy Slippers",
  brandToken: "b_xkh87elait",
  brandName: "Katydid",
  imageUrl: "https://cdn.faire.com/fastly/cb5914f893a1d6b300b295b4795fd6c6db4d4c2b5614600254fbb6ead530fa04.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/485eb224bb521d67c80ab0953dc5cedb7d0db2dbff6bbe2c0ecf194ce6b9a8d9.jpeg",
    "https://cdn.faire.com/fastly/735894518a153c80d3089c6ef8a5f1dea7d653a3188a3c602c35f5735951a995.jpeg",
    "https://cdn.faire.com/fastly/c8d6d278ac031c1fb61868c2662aebacf108823d3ca0123c5c7a2afd06f127b3.jpeg"
  ],
  priceDollars: 14,
  description: "• Hand wash warm; hang to dry.\n• S/M fits sizes 6-7, M/L fits sizes 8-9, L/XL fits size 10.",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T18:43:24.645Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
